const CONST = {
  SYS_ERR: '시스템에서 오류가 발생하였습니다. 잠시 후 다시 시도해주세요.'
};
export default CONST;



// WEBPACK FOOTER //
// ./src/constants/commonText.js